import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { Dispatch } from "redux"
import { syncOneCostCenter } from "~Shared/store/actions/costCenter/costCenterActions"
import { refetchTable } from "~Shared/store/actions/tables/tableActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToCostCenter = async (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.DELETE) {
            await dispatch(syncOneCostCenter(documentId))
            dispatch(refetchTable(TablesEnum.COST_CENTERS))
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Cost Center Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
